import { createSelector } from 'reselect';
import _intersection from 'lodash/intersection';
import _concat from 'lodash/concat';
import { FACET_ELEMENTS, FACETS_SHAPE } from '../../reducers/util/guestRailUtils';

const activeFacets = state => state.activeFacetElements;
const facetMatches = state => state.facetMatches;
const bucketKeys = Object.keys(FACETS_SHAPE);
const bucketElements = bucketKeys.reduce(
  (acc, key) => ({ ...acc, [key]: FACETS_SHAPE[key].elements })
  , {});
const elementKeys = Object.keys(FACET_ELEMENTS);

const getActiveBuckets = createSelector(
  activeFacets,
  (activeElements) => {
    return activeElements.reduce((acc, element) => {
      const { bucket } = FACET_ELEMENTS[element];
      return (acc.indexOf(bucket) !== -1) ? acc : [...acc, bucket];
    }, []);
  }
);

// collection of all checked people per bucket
const getActiveBucketSets = createSelector(
  getActiveBuckets,
  facetMatches,
  activeFacets,
  (activeBuckets, matches, activeElementsArr) => {
    if (activeElementsArr.length === 0) return {};
    return activeBuckets.reduce(
      (acc, bucket) => {
        const activeElements = bucketElements[bucket]
          .filter(element => activeElementsArr.indexOf(element) !== -1)
        const bucketSet = (activeElements.length > 0)
          ? activeElements.reduce((set, element) => _concat(matches[element], set), [])
          : false;
        return (bucketSet) ? { ...acc, [bucket]: bucketSet } : acc;
      }, {}
    );
  }
);

// for each bucket: people collection available
//    (contracted by selections from the other buckets)
const getActiveSubsets = createSelector(
  getActiveBucketSets,
  facetMatches,
  (activeBucketSets, matches) => {
  // for each element,
  // collect all non-parent 'activeBuckets'
  // ---if no non-parent 'activeBuckets' pass the element's 'facetMatches'
  //    collect those sets
  // run interstection on those sets & the element's 'facetMatches'
  return elementKeys.reduce(
    (acc, element) => {
      const parentBucket = element.bucket;
      const activeBucketKeys = Object.keys(activeBucketSets);
      const affectingBuckets = activeBucketKeys.filter(bucket => activeBucketSets[bucket] !== parentBucket);
      if (affectingBuckets.length === 0) return { ...acc, [element]: matches[element] };
      const limitingSet = affectingBuckets.reduce((set, bucket) => _concat(activeBucketSets[bucket], set), []);
      return { ...acc, [element]: _intersection(matches[element], limitingSet) };
    }, {});
  }
);

const getCurrentFacetCount = createSelector(
  getActiveSubsets,
  activeFacets,
  facetMatches,
  (activeSubsets, activeElements, matches) => {
    const elements = (activeElements.length === 0) ? matches : activeSubsets;
    return elementKeys.reduce((acc, element) => ({ ...acc, [element]: elements[element].length }), {})
  }
);


export default getCurrentFacetCount;



// WEBPACK FOOTER //
// ./src/selectors/seatingchart/guestRailSelector.js